﻿var jquery = require('jquery');
var HabEvents = require("../../Global/habitaclia-events");


(function () {
	"use strict";


    var AdWords = function () {
			__IncludeConversionTag();
			__registerAdWordsEvents.call(this);
	};

	var __IncludeConversionTag = function () {
		var script1 = document.createElement("script");
		script1.setAttribute("defer", true);
		script1.setAttribute("src", "//www.googleadservices.com/pagead/conversion_async.js");
		document.body.appendChild(script1);
	};

	var __sendConversion = function(conversionId, conversionLabel, codigoAnuncio) {
		window.google_trackConversion({
			google_conversion_id: conversionId,
			google_conversion_language: "es",
			google_conversion_format: "1",
			google_conversion_color: "ffffff",
			google_conversion_label: conversionLabel,
			google_conversion_value: 1,
			google_remarketing_only: false,
			google_custom_params: { listing_id: codigoAnuncio, listing_pagetype: 'conversionintent' }
		});
	};

	var __registerAdWordsEvents = function () {

		jquery.subscribe(HabEvents.EventsEnum.AdWordsConversion, function (e, codigoAnuncio) {

			if (typeof (window.google_trackConversion) !== "undefined") {

				console.log("Enviando AdwordsTrackConversion...");

				__sendConversion(1072659908, "ZxIdCLaqPxDE-73_Aw", codigoAnuncio); /* (CATAND-VENTA) */

				__sendConversion(1051454308, "YvkmCLrCShDk1q_1Aw", codigoAnuncio); /* (CATAND-ALQ) */

				__sendConversion(1034460238, "n874COykkAEQzrii7QM", codigoAnuncio); /* (?????) */

				__sendConversion(979264913, "RstWCPfi4QgQkcv50gM", codigoAnuncio); /* (LONGTAIL) */

				__sendConversion(908598431, "4LEXCIClmVsQn7mgsQM", codigoAnuncio); /* (VALENCIA) */

				__sendConversion(944428835, "sMnDCJvPyl8Qo66rwgM", codigoAnuncio); /* (MURCIA) */

				__sendConversion(821512173, "lefRCN2nvH4Q7Y_dhwM", codigoAnuncio); /* (MADRID) */

				__sendConversion(759125116, "TgImCJe8oZYBEPyo_ekC", codigoAnuncio); /* (ANDALUCIA) */

				__sendConversion(614219844, "wuNZCIbZndcBEMSA8aQC", codigoAnuncio); /* (NORTE) */

				__sendConversion(611723867, "cIN1CMOU_NgBENvU2KMC", codigoAnuncio); /* (VIDEO) */

			}

		});
	};

	AdWords.prototype = {
		constructor: AdWords
	};

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = new AdWords();
	}
	else {
		window.AdWords = new AdWords();
	}



}());